export const getHotelSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Hotel",
  "name": "Hotel Suvidha Deluxe",
  "description": "Premium hotel in Haridwar near Har Ki Pauri. Experience luxury accommodation, modern amenities, and authentic hospitality in the holy city of Haridwar, Uttarakhand.",
  "image": [
    "https://hotelsuvidhadeluxe.com/images/suvidhaf.webp",
    "https://hotelsuvidhadeluxe.com/images/family.webp",
    "https://hotelsuvidhadeluxe.com/images/reception.webp"
  ],
  "priceRange": "₹₹",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Sarvarnath Nagar, Near Har Ki Pauri",
    "addressLocality": "Haridwar",
    "addressRegion": "Uttarakhand",
    "postalCode": "249401",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "29.9457",
    "longitude": "78.1642"
  },
  "url": "https://hotelsuvidhadeluxe.com/",
  "telephone": "+91-8941000583",
  "email": "info@hotelsuvidhadeluxe.com",
  "starRating": {
    "@type": "Rating",
    "ratingValue": "4.5",
    "bestRating": "5"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "250"
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free WiFi",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free Parking",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Air Conditioning",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "24/7 Room Service",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Restaurant",
      "value": true
    }
  ],
  "checkinTime": "14:00",
  "checkoutTime": "11:00",
  "petsAllowed": false,
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card", "UPI"],
  "currenciesAccepted": "INR",
  "openingHours": "Mo-Su 00:00-24:00",
  "sameAs": [
    "https://facebook.com/hotels4u.in",
    "https://instagram.com/hotels4u.in",
    "https://twitter.com/hotels4u.in"
  ]
});

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "name": "Hotel Suvidha Deluxe",
  "alternateName": "Suvidha Deluxe Hotel Haridwar",
  "description": "Best hotel in Haridwar near Har Ki Pauri. Premium accommodation with modern facilities, perfect for pilgrims and tourists visiting Haridwar, Uttarakhand.",
  "url": "https://hotelsuvidhadeluxe.com",
  "logo": "https://hotelsuvidhadeluxe.com/logo_h4u.png",
  "image": "https://hotelsuvidhadeluxe.com/images/hotel-exterior.jpg",
  "telephone": "+91-8941000583",
  "email": "info@hotelsuvidhadeluxe.com",
  "priceRange": "₹₹",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Sarvarnath Nagar, Near Har Ki Pauri",
    "addressLocality": "Haridwar",
    "addressRegion": "UT",
    "postalCode": "249401",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 29.9457,
    "longitude": 78.1642
  },
  "hasMap": "https://www.google.com/maps/dir//Suvidha+Deluxe+Haridwar,+near+Shiv+Murti+Chowk,+Sharvan+Nath+Nagar,+Haridwar,+Uttarakhand+249401/@29.947019,78.1543002,17z/data=!4m20!1m11!3m10!1s0x39094798e1c9fe6b:0x6216743a56a37cd2!2sSuvidha+Deluxe+Haridwar!5m2!4m1!1i2!8m2!3d29.9470548!4d78.1590185!15sChRIb3RlbCBTdXZpZGhhIERlbHV4ZZIBBWhvdGVs4AEA!16s%2Fg%2F11s3cjttqy!4m7!1m0!1m5!1m1!1s0x39094798e1c9fe6b:0x6216743a56a37cd2!2m2!1d78.1590644!2d29.94702?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "opens": "00:00",
    "closes": "23:59"
  }
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getRoomSchema = (room) => ({
  "@context": "https://schema.org",
  "@type": "HotelRoom",
  "name": room.name,
  "description": room.description,
  "image": room.image,
  "bed": {
    "@type": "BedDetails",
    "numberOfBeds": 1,
    "typeOfBed": room.name.includes("Family") ? "King" : "Queen"
  },
  "occupancy": {
    "@type": "QuantitativeValue",
    "value": room.capacity
  },
  "amenity": room.amenities,
  "floorSize": {
    "@type": "QuantitativeValue",
    "value": room.size
  },
  "offers": {
    "@type": "Offer",
    "price": room.price,
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
});

export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const getArticleSchema = (article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "image": article.image,
  "datePublished": article.date,
  "dateModified": article.date,
  "author": {
    "@type": "Organization",
    "name": "Hotel Suvidha Deluxe"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Hotel Suvidha Deluxe",
    "logo": {
      "@type": "ImageObject",
      "url": "/images/logo_h4u.png"
    }
  },
  "description": article.excerpt
});
